import { CompanyHelper, type CompanyDetails } from '@models/next/Company';
import type { RoutePlanSimulatorStatus } from '@models/next/RoutePlanSimulator';

export class RoutePlanSimulatorHelper {
  static isCompanyRateLimited(
    company: CompanyDetails,
    routePlanSimulatorStatus: RoutePlanSimulatorStatus,
  ) {
    return !CompanyHelper.isMember(company) && routePlanSimulatorStatus.count >= 10;
  }
}
